import {
  fromWei,
  getFeesDeposited,
  getMinimumStakeAmount,
  getMinimumStakePeriod,
  getPotentialBalance,
  getRewardBalance,
  getStakeDetails,
  totalAmountStaked,
  totalOverallAmountStaked,
  getDemandFactor,
  registerProject,
  registerKOL,
  registerCampaign,
  investInCampaign,
  depositToken,
  withdrawReward,
  acceptMarketing,
  withdrawFundsProj,
  approveToken,
  checkApproval,
} from "../../contract/functions/functions";
// import { checkApproval } from "../../contract/functions/ERC20functions";
import fetch from "../../utils/fetch";
import * as uiTypes from "../types/uiTypes";
import { abi as ERC20ABI } from "../../contract/abi/ERC20Abi.json";
import Web3 from "web3";

import * as web3Types from "../types/web3Types";
// import { setLoading } from "./uiActions";
import {
  API_BASE_URL,
  GRAPH_BASE_URL,
  PROTOKOL_CONTRACT_ADDRESS,
} from "../../contract/constants";
import moment from "moment";
import axios from "axios";

export const storeWeb3Context = (data) => {
  return (dispatch) => {
    dispatch({ type: web3Types.STORE_WEB3_CONTEXT, payload: data });
  };
};

export const addProject = async (
  walletAddress,
  data,
  tokenData,
  callbackFunction,
  dispatch
) => {
  // console.log("addProject daata => ", data);

  const body = { ...data };

  delete body["_id"];
  console.log(
    "addProject + tokenData + walletAdd body => ",
    body,
    tokenData,
    walletAddress
  );

  try {
    let response = await fetch(
      // "https://55a3-202-47-35-31.ngrok.io/projects/addProject",
      "https://protokol-server.herokuapp.com/projects/addProject",

      { ...body, walletAddress },
      "POST"
    );
    console.log("addProject Response => ", response.payload);
    const { marketingBudget } = body;
    const {
      circulatingSupply,
      preSalePrice,
      launchPrice,
      maxSupply,
    } = tokenData;

    console.log("add destruct => ", marketingBudget, circulatingSupply);

    dispatch({
      type: uiTypes.SET_LOADING,
      payload: true,
    });
    const regProject = await registerProject(
      response.payload.project._id,
      walletAddress,

      marketingBudget,
      maxSupply,
      circulatingSupply,
      preSalePrice,
      launchPrice,
      callbackFunction,
      dispatch
    );
    console.log("regProject addcontract  => ", regProject);

    return response;
  } catch (error) {
    console.log("addProject Error => ", error);
    return error;
  }
};

export const addToken = (
  walletAddress,
  projectData,
  data,
  callbackFunction
) => async (dispatch) => {
  // console.log("addProject data => ", projectData);

  const pData = await addProject(
    walletAddress,
    projectData,
    data,
    callbackFunction,
    dispatch
  );
  // console.log("pdata(addProject) response => ", pData);

  dispatch({
    type: uiTypes.SET_PROJECT_DATA,
    payload: pData.payload.project,
  });
  console.log("addToken pdata => ", {
    ...data,
    id: pData.payload.project._id,
  });
  try {
    let response = await fetch(
      "https://protokol-server.herokuapp.com/tokenomics/addToken",
      // {...data, id: pData.payload.project._id },
      {
        ...data,
        id: pData.payload.project._id,
      },
      "POST"
    );
    // let response = await axios.post(
    //   "https://protokol-server.herokuapp.com/tokenomics/addToken",
    //   // "http://d813-103-31-100-63.ngrok.io/tokenomics/addToken",
    //   { ...data, id: pData.payload.project._id }
    // );
    console.log("addToken Response => ", response);
    dispatch({
      type: uiTypes.SET_PROJECT_DATA,
      payload: response.payload,
    });
    // return response;
  } catch (error) {
    console.log("addToken Error => ", error);
    // return error;
  }
};
export const addKol = (data, callbackFunction) => async (dispatch) => {
  console.log("addKol data => ", data);
  try {
    let response = await fetch(
      "https://protokol-server.herokuapp.com/kol/addKol",
      data,
      "POST"
    );
    console.log("addKol Response => ", response);
    dispatch({
      type: uiTypes.SET_KOL_DATA,
      payload: response.payload.Kol,
    });
    dispatch({
      type: uiTypes.SET_LOADING,
      payload: true,
    });
    const regKol = await registerKOL(
      data?.walletAddress,
      response?.payload?.Kol?._id,
      callbackFunction,
      dispatch
    );
    console.log("addKol regKol => ", data?.walletAddress, regKol);
    console.log("addKol kolid => ", response?.payload?.Kol?._id);

    // return response;
  } catch (error) {
    console.log("addKol Error => ", error);
    // return error;
  }
};

export const addCampaign = (
  sourceAddress,
  projectData,
  data,
  callbackFunction
) => async (dispatch) => {
  const body = { ...data };

  delete body["_id"];
  const projectId = projectData._id;
  console.log("addCampaign data => ", body, projectId);
  try {
    let response = await fetch(
      // "https://41bd-110-93-239-166.ngrok.io/campaign/addCampaign",
      "https://protokol-server.herokuapp.com/campaign/addCampaign",
      { ...body, projectId },
      "POST"
    );

    console.log("addCampaign Response => ", response);
    if (response.status !== 201) {
      console.log("HAHAHHAHAHHAHH");
      dispatch(
        setShowSnackbar({
          open: true,
          message: "Error In Creating Campaign",
        })
      );
    } else {
      dispatch({
        type: uiTypes.SET_CAMPAIGN_DATA,
        payload: response.payload,
      });
    }
    console.log("projectData .id", projectData._id);
    const { totalFollowersRequired, budget } = data;
    // console.log("add totalFollowersRequired", totalFollowersRequired, data.budget);

    // dispatch(pulsarProject());
    // console.log("add pulsarResponse", pulsarResponse);

    dispatch({
      type: uiTypes.SET_LOADING,
      payload: true,
    });
    const regCam = await registerCampaign(
      response.payload._id,
      sourceAddress,
      projectData._id,
      Number(totalFollowersRequired),
      "0x0000000000000000000000000000000000000000",
      Number(budget),
      true,
      callbackFunction,
      dispatch
    );
    console.log("addCam contract regCam => ", regCam);
  } catch (error) {
    console.log("addCampaign Error => ", error);
    // return error;
  }
};

export const getCampaigns = (kolId) => async (dispatch) => {
  console.log("getCampaigns body kolid => ", kolId);
  try {
    let response = await fetch(
      `https://protokol-server.herokuapp.com/campaign/getCampaigns/${kolId}`,
      null,
      "GET"
    );
    console.log("getCampaigns Response => ", response);
    dispatch({
      type: uiTypes.SET_ALL_CAMPAIGN_DATA,
      payload: response.payload,
    });
    // return response;
  } catch (error) {
    console.log("getCampaigns Error => ", error);
    // return error;
  }
};

export const isUser = (walletAddress) => async (dispatch) => {
  console.log("isuser walletAddress  body=> ", walletAddress);

  try {
    let response = await fetch(
      `https://protokol-server.herokuapp.com/projects/checkUser/${walletAddress}`,
      null,
      "GET"
    );
    console.log("isUser Response => ", response);

    if (response.payload.project !== null) {
      // if (response.payload.project) {
      //   console.log("isUser PROJECT ");
      //   dispatch({
      //     type: uiTypes.SET_IS_USER,
      //     payload: response.payload.project,
      //   });
      // }
      // if (response.payload.kol) {
      //   console.log("isUser KOLLLLLLLLLLLLL ");
      dispatch({
        type: uiTypes.SET_IS_USER,
        payload: response.payload,
      });
      // }
      // console.log("isUser ANDAR AGAYA MAI ");
    }
    // return response;
  } catch (error) {
    console.log("isUser Error => ", error);
    // return error;
  }
};

export const setShowSnackbar = ({ open, message }) => {
  return async (dispatch) => {
    dispatch({
      type: web3Types.SHOW_SNACKBAR,
      payload: {
        open,
        message,
      },
    });
  };
};

export const investCampaign = (
  budget,
  followers,
  walletAddress,
  body
) => async (dispatch) => {
  console.log(
    "investCampaign budget followers walletAddress body => ",
    budget,
    followers,
    walletAddress,
    body
  );

  try {
    let response = await fetch(
      `https://protokol-server.herokuapp.com/campaign/investCampaign`,
      body,
      "POST"
    );
    console.log("investCampaign Response => ", response);
    // dispatch({
    //   type: uiTypes.SET_LOADING,
    //   payload: true,
    // });
    const campaignId = body.campaignId;
    if (response.payload.status == 400) {
      dispatch(
        setShowSnackbar({
          open: true,
          message: response.payload.msg,
        })
      );
    } else {
      dispatch({
        type: uiTypes.SET_INVESTMENT_DATA,
        payload: response.payload,
      });
    }
    // console.log(
    //   "investCampaign budget followers walletAddress body => ",
    //   walletAddress,
    //   response.payload._id,
    //   campaignId,
    //   budget,
    //   followers
    // );

    let tokenApproval = await checkApproval(
      "0x1F5F895FA0788fE6771B6F60B0D43eed7c862CB1", //token address here
      PROTOKOL_CONTRACT_ADDRESS,
      walletAddress
    );
    if (!tokenApproval) {
      let checkApproval = await approveToken(
        "0x1F5F895FA0788fE6771B6F60B0D43eed7c862CB1", //token address here
        PROTOKOL_CONTRACT_ADDRESS,
        walletAddress
      );
    }
    if (response.payload._id) {
      // console.log(object)
      dispatch({
        type: uiTypes.SET_LOADING,
        payload: true,
      });
      const investCampaignContract = await investInCampaign(
        walletAddress,
        response.payload._id,
        campaignId,
        budget,
        followers,
        body.invested,
        dispatch
      );
    }
  } catch (error) {
    console.log("investCampaign Errorrrrrrrrrrrrr => ", error);
    dispatch({
      type: uiTypes.SET_ERROR_DATA,
      payload: error.payload.message,
    });
  }
};

// export const pulsarProject = () => async (dispatch) => {
//   try {
//     let response = await fetch(
//       "https://protokol.pulsarplatform.com/api/v3/trac/searches/",
//       {
//         name: "Example11",
//         search_type_cd: 0,
//         input_format: 0,
//         start_date: "2021-09-01",
//         end_date: "2021-09-19",
//         category_ids: [101],
//         keywords: [["xord"]],
//       },
//       "POST",
//       "eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoyMTQ2MSwidXNlcl92ZXJzaW9uIjoiMjAyMS0wOS0wOCAwNDo1OTowMyAtMDcwMCIsInNhbWVfb3JpZ2luIjpmYWxzZX0.JqPdHjAva6ATgRQ2Jg7zh_0j7NN0gT01dmeNY1XYFbg"
//     );
//     console.log("pulsarProject Response => ", response);
//   } catch (error) {
//     console.log("pulsarProject Error => ", error);
//     // return error;
//   }
// };

export const getTableData = (kolId) => async (dispatch) => {
  try {
    let response = await fetch(
      `https://protokol-server.herokuapp.com/campaign/getClaimable/${kolId}`,
      null,
      "GET"
    );
    console.log("tableData kolid + Response => ", kolId, response);

    dispatch({
      type: uiTypes.SET_TABLE_DATA,
      payload: response.payload,
    });
  } catch (error) {
    console.log("tableData Error => ", error);
  }
};

export const getGraphqlData = (kolId) => async (dispatch) => {
  try {
    let response = await fetch(
      `https://protokol-server.herokuapp.com/campaign/getposttable/${kolId}`,
      null,
      "GET"
    );
    console.log(
      "GRAPHQL DATA kolid + Response => ",
      kolId,

      response
    );

    dispatch({
      type: uiTypes.SET_GRAPHQL_DATA,
      payload: response.payload,
    });
  } catch (error) {
    console.log("Graphql Error => ", error);
  }
};
// export const payFee = async (
//   dafiAmount,
//   usdtAmount,
//   sourceAddress,
//   successCallback,
//   onPaymentFailed
// ) => {
//   try {
//     let dafiApproval = await checkApproval(
//       DAFI_ADDRESS,
//       DAFI_ADMIN_PANEL_CONTRACT_ADDRESS,
//       sourceAddress
//     );
//     let usdtApproval = await checkApproval(
//       USDT_ADDRESS,
//       DAFI_ADMIN_PANEL_CONTRACT_ADDRESS,
//       sourceAddress
//     );
//     console.log({ usdtApproval, dafiApproval });
//     if (!dafiApproval) {
//       await approveToken(
//         DAFI_ADDRESS,
//         DAFI_ADMIN_PANEL_CONTRACT_ADDRESS,
//         sourceAddress
//       );
//       dafiApproval = await checkApproval(
//         DAFI_ADDRESS,
//         DAFI_ADMIN_PANEL_CONTRACT_ADDRESS,
//         sourceAddress
//       );
//     }
//     if (!usdtApproval) {
//       await approveToken(
//         USDT_ADDRESS,
//         DAFI_ADMIN_PANEL_CONTRACT_ADDRESS,
//         sourceAddress
//       );
//       usdtApproval = await checkApproval(
//         USDT_ADDRESS,
//         DAFI_ADMIN_PANEL_CONTRACT_ADDRESS,
//         sourceAddress
//       );
//     }
//     if (dafiApproval && usdtApproval) {
//       let response = await dafiAdminPanelContract.methods
//         .payFee(dafiAmount, usdtAmount)
//         .send({ from: sourceAddress })
//         .on("transactionHash", (hash) => {})
//         .on("confirmation", function (confirmationNumber, receipt) {
//           if (confirmationNumber === 1) {
//           }
//         });
//       successCallback();
//       console.log("payFee response => ", response);
//     }
//   } catch (error) {
//     console.log("Error => ", error);
//     onPaymentFailed();
//   }
// };
export const depositTokenProject = (
  walletAddress,
  projectId,
  tokenAddress,
  tokenAmount,
  callbackFunction
) => async (dispatch) => {
  try {
    // let response = await fetch(
    //   `https://protokol-server.herokuapp.com/getClaimable/${kolId}`,
    //   null,
    //   "GET"
    // );
    console.log(
      "depositToken body => ",
      walletAddress,
      projectId,
      tokenAddress,
      tokenAmount
    );

    // let tokenApproval = await checkApproval(
    //   "0x5186a9ed44b1011be7e1aaef9c1bc9eaf327cd5b", //token address here
    //   PROTOKOL_CONTRACT_ADDRESS,
    //   walletAddress
    // );
    // if (!tokenApproval) {
    //   let checkApproval = await approveToken(
    //     "0x5186a9ed44b1011be7e1aaef9c1bc9eaf327cd5b", //token address here
    //     PROTOKOL_CONTRACT_ADDRESS,
    //     walletAddress
    //   );
    // }
    const depositTokenContractResponse = await depositToken(
      walletAddress,
      projectId,
      // tokenAddress,
      tokenAmount,
      callbackFunction
    );
  } catch (error) {
    console.log("depositToken Error => ", error);
  }
};

export const withdrawRewardKol = (
  walletAddress,
  campaignId,
  withdrawValue,
  callbackFunction
) => async (dispatch) => {
  try {
    console.log(
      "withdrawReward body => ",
      walletAddress,
      campaignId,
      withdrawValue
    );

    const { payload, status } = await fetch(
      `https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd&include_24hr_vol=true&include_24hr_change=true`,
      null,
      "get"
    );
    console.log("Bilal", payload);
    const withdrawRewardResponse = await withdrawReward(
      walletAddress,
      campaignId,
      (withdrawValue / payload.ethereum.usd).toFixed(5),
      callbackFunction
    );
  } catch (error) {
    console.log("withdrawReward Error => ", error);
  }
};

export const withdrawFundsProject = (
  walletAddress,
  campaignId,
  withdrawValue,
  callbackFunction
) => async (dispatch) => {
  try {
    console.log(
      "withdrawFundsProject body => ",
      walletAddress,
      campaignId,
      withdrawValue
    );

    const withdrawFundsProjectResponse = await withdrawFundsProj(
      walletAddress,
      campaignId,
      withdrawValue,
      callbackFunction
    );
  } catch (error) {
    console.log("withdrawFundsProject Error => ", error);
  }
};

// export const acceptMarketingKol = (
//   walletAddress,
//   investmentId,
//   rewardAmount
// ) => async (dispatch) => {
//   try {
//     // let response = await fetch(
//     //   `https://protokol-server.herokuapp.com/getClaimable/${kolId}`,
//     //   null,
//     //   "GET"
//     // );
//     console.log(
//       "acceptMarketing body => ",
//       walletAddress,
//       investmentId,
//       rewardAmount
//     );

//     const acceptMarketingResponse = await acceptMarketing(investmentId);
//   } catch (error) {
//     console.log("acceptMarketing Error => ", error);
//   }
// };

export const getClaimablebyProjectId = async (projectId) => {
  console.log("getClaimablebyProjectId body", projectId);
  try {
    let response = await fetch(
      `https://protokol-server.herokuapp.com/campaign/getClaimablesByProjectId/${projectId}`,
      null,
      "GET"
    );
    console.log(
      "getClaimablebyProjectId projectId + Response => ",
      projectId,
      response
    );
    return response.payload;
  } catch (error) {
    console.log("getClaimablebyProjectId Error => ", error);
  }
};
export const getClaimablebyKolId = async (kolId) => {
  console.log("getClaimablebyKolId body", kolId);
  try {
    let response = await fetch(
      `https://protokol-server.herokuapp.com/campaign/getClaimable/${kolId}`,
      null,
      "GET"
    );
    console.log(
      "getClaimablebyKolId projectId + Response => ",
      kolId,
      response
    );
    return response.payload;
  } catch (error) {
    console.log("getClaimablebyKolId Error => ", error);
  }
};

export const updateProject = (projectId, body) => async (dispatch) => {
  try {
    let response = await fetch(
      `https://protokol-server.herokuapp.com/project/updateProject/${projectId}`,
      body,
      "Post"
    );
    console.log("updateProject projectId + Response => ", projectId, response);
  } catch (error) {
    console.log("updateProject Error => ", error);
  }
};

export const getCampaignFollowers = async (camId) => {
  try {
    let response = await fetch(
      `https://protokol-server.herokuapp.com/campaign/getCampaignFollower/${camId}`,
      null,
      "GET"
    );
    console.log(
      "getCampaignFollowers projectId + Response => ",
      response,
      camId
    );
    return response.payload.followerCount;
  } catch (error) {
    console.log("getCampaignFollowers Error => ", error);
  }
};
//localhost:3002/campaign/getCampaignFollower/:campaignId
 export const setAppLoading = (flag) => {
  console.log("coming here setAppLoading");
  return async (dispatch) => {
    dispatch({ type: web3Types.SET_CHAIN_DATA, payload: { appLoading: flag } });
  };
};
